<div class="text-center">
  <a [routerLink]="['/batch/groups/index']" class="me-2 btn btn-primary"><i class="fa fa-list"></i>Cancel</a>
  </div>

<div class="text-center" *ngIf="subscriptionGroup  && subscriptionGrouping">
 Editing  {{subscriptionGrouping.name}} for {{subscriptionGroup.name}}
</div>

<div class="text-center" *ngIf="subscriptionGroup  && !subscriptionGrouping">
  New  Grouping  for {{subscriptionGroup.name}}
 </div>

<form [formGroup] = "myForm" (ngSubmit)="on_submit()" class="form" enctype="multipart/form-data" *ngIf="!loading">
  <div class="form-group row" [ngClass]="{error:f.name.errors && f.name.touched}">
      <label for="subjectId" class='control-label col-sm-3'>Group Name</label>
          <div class="input-group controls col-sm-8">
            <input type="text" id="name" formControlName="name" class="form-control">
          </div>
          <div *ngIf="f.name.errors && f.name.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
            <ul>
                <li>Name Required.</li>
            </ul>
        </div>
    </div>
    <div class="form-group row" [ngClass]="{error:f.description.errors && f.name.touched}">
      <label for="subjectId" class='control-label col-sm-3' >Description</label>
          <div class="input-group controls col-sm-8">
            <input type="text" id="description" formControlName="description" class="form-control">
          </div>
          <div *ngIf="f.description.errors && f.description.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
            <ul>
                <li>Description Required.</li>
            </ul>
        </div>
    </div>
    <div class="form-group row" [ngClass]="{error:f.country.errors && f.country.touched}">
      <label for="country" class='control-label col-sm-3'>Country of Study<span class="required-asteric">*</span></label>
          <div class="input-group controls col-sm-8">
              <select class="form-control" id="country"  #myCountry formControlName="country" >
                  <option *ngFor="let country of countries" [value]="country.id">{{country.name}}</option>
              </select>
              <div *ngIf="f.country.errors && f.country.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                  <ul>
                      <li>Country  is required.</li>
                  </ul>
              </div>
          </div>
  </div>
  <div class="form-group row" [ngClass]="{error:f.curriculum.errors && f.curriculum.touched}">
    <label for="curriculum" class='control-label col-sm-3'>Curriculum<span class="required-asteric">*</span></label>
        <div class="input-group controls col-sm-8">
            <select class="form-control" id="curriculum"  #myCurriculum formControlName="curriculum"
            (change)='loadLevels(myCountry.value)'>
                <option *ngFor="let curriculum of curriculums" [value]="curriculum.id">{{curriculum.name}}</option>
            </select>
            <div *ngIf="f.curriculum.errors && f.curriculum.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                <ul>
                    <li>Curriculum  is required.</li>
                </ul>
            </div>
        </div>
</div>
    <div class="form-group row" [ngClass]="{error:f.level.errors && f.level.touched}" *ngIf="levels.length>0">
      <label for="level" class='control-label col-sm-3'>Level<span class="required-asteric">*</span></label>
          <div class="input-group controls col-sm-8">
              <select class="form-control" id="level"  #myLevel formControlName="level"
              (change)='onLevelOptionsSelected(myLevel.value)'>
                  <option *ngFor="let level of levels" [value]="level.id">{{level.name}}</option>
              </select>
              <div *ngIf="f.level.errors && f.level.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                  <ul>
                      <li>Level  is required.</li>
                  </ul>
              </div>
          </div>
  </div>
  <div class="form-group row"  *ngIf="subjects.length>0">
    <label for="subjectId" class='control-label col-sm-3' >Subject</label>
        <div class="input-group controls col-sm-8">
          <table class='table'>
            <tr *ngFor="let subject of subjects; index as myCount">
              <td>
                <input type="checkbox"  [value]="subject.id" formControlName="subjectIdDecoy"> {{subject.name}}

              </td>
            </tr>
          </table>
        </div>
</div>

<div class="text-center" *ngIf="myForm.valid">
  <button [disabled]="isSaving" type="submit" class="btn btn-primary mt-3">
    <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"></span>
    Submit
</button>
</div>

</form>
